import React, { Fragment, useContext } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { Picture } from '_ui-core-js/React/components/Picture.jsx';
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { NavigationContext } from '../store/contexts/NavigationContext';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js//constants/analytics.js';
import { fireGTMTrackingEvent } from '_ui-core-js/utilities/fireGTMTrackingEvent.js';

export function AtmosphereImage(props) {
  
  const { 
	base, 
	animationDelay, 
	showExpandIcon, 
	id,
	gtmComponentName,
	gtmComponentGroup
  } = props;

  const { navigate } = useContext(NavigationContext);

  function clickHandler() {
	fireGTMTrackingEvent({
	  name: CORE_GTM_TRACKING_VALUES.name.componentEvent,
	  componentName: gtmComponentName, 
	  componentGroup: gtmComponentGroup,
	  action: CORE_GTM_TRACKING_VALUES.action.viewPicture,
	  label: base
	});
	navigateTo();
  };

  function navigateTo() {
	let path = '/inspiration'
	if (id) {
	  path += '/' + id;
	}
	navigate(path);
  };

  return (
	<CssAnimation 
	enter={{ name: 'vertical-top-bottom-clip',  duration: 1, delay: `${animationDelay}, hidden`, easing: 'ease-out' }} 
	triggerEnter={'in-view-init'}
	>
	  <div>
		<CssAnimation 
		enter={{ name: 'vertical-top-bottom-reveal', target: 'psuedo-element-after', duration: 0.75, delay: `${animationDelay + 0.5}`, easing: 'ease-out' }} 
		triggerEnter={'in-view-init'}
		>
			<div className={classNames({
				'apply-lbx-theme-background-after': true,
				'utils__add-expand-icon-before': showExpandIcon
			})}> 
				<Picture 
			  	base={base}
				{...( showExpandIcon && { onClick: clickHandler })}
				/>
		  	</div>
		</CssAnimation>
	  </div>
	</CssAnimation>
  )
};

AtmosphereImage.defaultProps = {
	animationDelay: 0,
	gtmComponentName: CORE_GTM_TRACKING_VALUES.componentName.galleryImage,
	gtmComponentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.campaigns
};

AtmosphereImage.propTypes = {
	base: propTypes.string.isRequired,
  	animationDelay: propTypes.number,
  	showExpandIcon: propTypes.bool,
	id: propTypes.string,
 	gtmComponentName: propTypes.string,
	gtmComponentGroup: propTypes.string
};